module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/MV-3d5b4d86ce422d62c0c137e5cdb331be.png";